import React, {
    Component
} from 'react';

import {
    connect
} from 'react-redux'

import {
    getSelectedState
} from '../selectors/index'

import {
    map
} from 'lodash-es'

import {
    propertyClassName
} from '../utils/parsers'

import classNames from 'classnames'

class SelectedItem extends Component {
    renderIcon(item) {
        const {showIcon = true, property} = this.props;
        if (!showIcon) {
            return null;
        }
        const {description} = item;
        const check = <span className="check-circled icon-yc-checkmark"/>;
        if (property === 'accentPanel') {
            return <span className={classNames("accent-panel-color", propertyClassName(description))}>{check}</span>
        }
        return check;
    }

    renderItem = (item, i) => {
        const {description, price} = item;
        const {className = 'current-choice', currency = '€'} = this.props;
        return (
            <div className={className} key={i}>
                {this.renderIcon(item)}
                <div className="choice-description">
                    <span className="item-title">{description}</span>
                    {!price || <span className="price">{price}{currency}</span>}
                </div>
            </div>
        );
    };

    renderDefaultText() {
        const {className = 'current-choice', defaultText} = this.props;
        if (defaultText) {
            return (
                <div className={className}>
                    <span className="choice-description">
                        {defaultText}
                    </span>
                </div>
            )
        }
    }

    render() {
        const {items = []} = this.props;
        if (!items.length) {
            return this.renderDefaultText();
        }
        return <span>{map(items, this.renderItem)}</span>;
    }
}

const mapStateToProps = (state, props) => {
    const {property} = props;
    if (!property || !state[property]) {
        throw new Error(`Invalid property ${property}`);
    }
    return {
        items: getSelectedState(state)[property].options,
        currency: state.currency
    }
};

export default connect(mapStateToProps)(SelectedItem);




// WEBPACK FOOTER //
// ./src/components/SelectedItem.js